/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import debounce from 'lodash/debounce';
import cn from 'clsx';
import { SearchOutlined } from '@ant-design/icons';
import { AModal, AButton, AInput, ASpin } from 'components/Antd';
import T from 'i18n-react';
import EntityBlock from 'views/DocumentManagement/components/SaveToModal/EntityBlock';
import useInfiniteScroll from 'hooks/useInfiniteScroll';
import { applySearch } from 'util/search';
import { getFields } from './utils';
import { useEntityActions } from './useEntityActions';
import classes from './SelectEntityModal.module.scss';
import { useEffect } from 'react';

let page = 1;

const SelectEntityModal = ({ open, onClose, entity, onSubmit, defaultSelectedItems }) => {
  const { list, metaData, refetch, isLoading } = useEntityActions(entity);
  const [search, setSearch] = useState('');
  const [isLazyLoading, setLazyLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const selectedItemIds = selectedItems.map((item) => item.id);
  const defaultSelectedItemIds = (defaultSelectedItems || []).map((item) => item.id);

  const loadMore = () => {
    setLazyLoading(true);
    page = page + 1;
    refetch(page, search, () => {
      setLazyLoading(false);
    });
  };
  useInfiniteScroll({
    elementId: 'list-wrapper',
    onLoadMore: loadMore,
    shouldLoadMore: !isLazyLoading && page < metaData.pages,
    threshold: 400,
  });

  useEffect(() => {
    page = 1;
    setSelectedItems(defaultSelectedItems || []);
  }, []);

  return (
    <AModal
      title={`Select ${entity}`}
      open={open}
      onCancel={onClose}
      closable
      width={648}
      className={cn(classes.modalWrapper)}>
      <div className={classes.content}>
        <div className={classes.searchWrapper}>
          <AInput
            addonBefore={<SearchOutlined />}
            placeholder={`Search by ${(entity || '').toLowerCase()} name & ID`}
            size="large"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              applySearch(e.target.value, (tVal) => {
                page = 1;
                refetch(1, tVal);
              });
            }}
            className={classes.searchInput}
          />
        </div>
        <div className={classes.listWrapper} id="list-wrapper">
          {isLoading && (
            <div className={classes.loading}>
              <ASpin />
            </div>
          )}
          {/* <h2 className={classes.listTitle}>Selected Related {entity}</h2>
          <div className={classes.list}>
            <EntityBlock fields={supplierFields} name="1stDibs" entity={entity} fromModal unbox />
            <EntityBlock fields={supplierFields} name="1stDibs" entity={entity} fromModal unbox />
            <EntityBlock fields={supplierFields} name="1stDibs" entity={entity} fromModal unbox />
          </div> */}
          <h2 className={classes.listTitle}>All {entity}</h2>
          <div className={classes.list}>
            {[
              ...(defaultSelectedItems || []),
              ...list.filter((obj) => !defaultSelectedItemIds.includes(obj.id)),
            ].map((obj) => {
              const isSelected = selectedItemIds.includes(obj.id);
              return (
                <EntityBlock
                  fields={getFields(entity, obj)}
                  name={obj?.name}
                  entity={entity}
                  fromModal
                  unbox
                  data={{
                    ...obj,
                    status: obj?.isActive ? 'active' : 'inactive',
                  }}
                  isSelected={isSelected}
                  onSelectChanged={() => {
                    setSelectedItems((prev) => {
                      if (isSelected) {
                        return prev.filter((item) => item.id !== obj.id);
                      }
                      return [...prev, obj];
                    });
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className={classes.footer}>
        <AButton
          onClick={() => {
            if (onSubmit) onSubmit(selectedItems);
          }}
          htmlType="button"
          type="primary"
          size="large"
          disabled={!selectedItems.length}
          className={classes.confirmBtn}>
          Confirm
        </AButton>
      </div>
    </AModal>
  );
};

export default SelectEntityModal;
